{
  "page": {
    "refreshed": "Actualisé {{when}}",
    "failedToLoad": "Échec du chargement des données analytiques :",
    "initializing": "Les analyses sont en cours d'initialisation",
    "initializingBody": "Les analyses préparent leur premier instantané. Cette page s'actualisera automatiquement dès que les données seront prêtes (généralement en moins de 60 secondes).",
    "outdatedTitle": "Les données analytiques sont peut-être obsolètes",
    "outdatedBody": "Dernière actualisation réussie : {{when}}. Dernière tentative en échec : {{error}}",
    "refreshedUnknown": "inconnu",
    "noWorkspacesTitle": "Aucun espace de travail {{type}} pour le moment",
    "noWorkspacesBody": "Ce type de service n'a aucun espace de travail à agréger. Changez de type de service via le sélecteur ci-dessus, ou revenez une fois le premier créé."
  },
  "filters": {
    "preset7d": "7 j",
    "preset30d": "30 j",
    "preset90d": "90 j",
    "preset1yr": "1 an",
    "custom": "Personnalisé",
    "customRange": "Personnalisé : {{from}} – {{to}}",
    "customDateRange": "Plage de dates personnalisée",
    "from": "Du",
    "to": "Au",
    "apply": "Appliquer",
    "clear": "Effacer",
    "all": "Tous",
    "filterColumn": "Filtrer {{label}}",
    "filterAria": "Filtrer {{label}}",
    "noOptions": "Aucune option",
    "clearFilters": "Effacer les filtres",
    "sortLabel": "Tri : {{column}} {{direction}}"
  },
  "time": {
    "justNow": "à l'instant",
    "minAgo": "il y a {{count}} min",
    "hourAgo_one": "il y a {{count}} heure",
    "hourAgo_other": "il y a {{count}} heures",
    "dayAgo_one": "il y a {{count}} jour",
    "dayAgo_other": "il y a {{count}} jours",
    "minAgoShort": "il y a {{count}} min",
    "hourAgoShort": "il y a {{count}} h",
    "dayAgoShort": "il y a {{count}} j"
  },
  "kpi": {
    "totalWorkspaces": "Espaces de travail totaux",
    "totalWorkspaces_validation": "Validations totales",
    "totalWorkspaces_auditing": "Audits totaux",
    "totalWorkspaces_development": "Développements totaux",
    "totalWorkspacesTooltip": "Nombre d'espaces de travail pour le type de service sélectionné ci-dessus. Choisissez Tous les types de service pour le total du portefeuille.",
    "completed": "Terminés",
    "completedSubClean": "{{clean}} sans erreur · {{withErrors}} avec erreurs",
    "completedSubPercent": "{{percent}} % du total",
    "totalIssues": "Problèmes totaux",
    "issuesBySeverity": "T1 : {{t1}} · T2 : {{t2}} · T3 : {{t3}} · T4 : {{t4}}",
    "timeSaved": "Temps économisé",
    "timeSavedNoData": "Indisponible — la date d'achèvement n'est pas enregistrée",
    "timeSavedSub_one": "≈ {{weeks}} semaine ETP · d'après {{count}} espace de travail mesuré",
    "timeSavedSub_other": "≈ {{weeks}} semaines ETP · d'après {{count}} espaces de travail mesurés",
    "timeSavedSubWeeksOnly": "≈ {{weeks}} semaines ETP",
    "timeSavedTooltip": "Une estimation fondée sur une hypothèse. Pour chaque espace de travail terminé, on part de 120 heures — le coût supposé d'une validation complète réalisée sans cette chaîne automatisée, planification, préparation des données, analyses et rédaction comprises — dont on retranche le temps réellement écoulé entre la création de l'espace de travail et le moment où il a atteint son état final ; les résultats sont ensuite additionnés. Ces 120 heures sont une hypothèse forfaitaire appliquée à tous les espaces de travail, et non une valeur mesurée mission par mission. Seuls les espaces de travail ayant atteint leur état final après le début de cette mesure sont pris en compte. Ceux qui existaient déjà à ce moment-là sont signalés comme antérieurs et restent exclus définitivement — leur date d'achèvement n'a jamais été enregistrée et n'est jamais estimée après coup — ce total ne couvre donc qu'une partie du portefeuille. La ligne sous le chiffre indique sur combien d'espaces de travail il repose.",
    "timeSavedTooltipNoData": "Actuellement indisponible. Le calcul du temps gagné exige de connaître la date de fin de chaque espace de travail, et aucun espace terminé dans cette vue n’a de date de fin enregistrée ; il n’y a donc rien à mesurer.",
    "totalRuns30d": "Exécutions totales (30 j)",
    "activeRuns": "Exécutions actives",
    "successRate": "Taux de réussite",
    "avgTime": "Durée moyenne"
  },
  "severity": {
    "fallback": "Type {{n}}"
  },
  "sections": {
    "portfolioTitle": "Vue d'ensemble du portefeuille",
    "portfolioDescription": "Modèles par domaine de service principal et leur progression",
    "issuesOverviewTitle": "Vue d'ensemble des problèmes et risques",
    "issuesOverviewDescription": "Distribution de gravité dans le portefeuille et ventilation par modèle",
    "workspacePipelineTitle": "Pipeline des espaces de travail",
    "workspacePipelineDescription": "Tous les espaces de travail — progression des sections, lacunes de données et problèmes par espace",
    "issuesDetailsTitle": "Détails des problèmes et risques",
    "issuesDetailsDescription": "Problèmes de cause racine avec symptômes à l’appui et liens vers les espaces de travail",
    "toolboxUsageTitle": "Utilisation de la boîte à outils",
    "toolboxUsageDescription": "Exécutions d'outils dans la boîte à outils des espaces de travail",
    "consumptionTitle": "Consommation de jetons",
    "consumptionDescription": "Utilisation des jetons LLM ce mois-ci — tous les espaces de travail et exécutions de la boîte à outils",
    "recentActivityTitle": "Activité récente",
    "recentActivityDescription": "Transitions d'état du flux des dernières 24 heures"
  },
  "chart": {
    "rendering": "Tracé du graphique…",
    "renderStalled": "Ce graphique met plus de temps que d'habitude à s'afficher. Les chiffres ci-dessous ne sont pas affectés."
  },
  "portfolio": {
    "byVertical": "Par verticale",
    "byProgress": "Par progression",
    "byServiceType": "Par type de service",
    "serviceTypeLabels": {
      "validation": "Validation",
      "auditing": "Audit",
      "development": "Développement"
    },
    "noWorkspaces": "Aucun espace de travail à afficher.",
    "modelCount_one": "{{count}} modèle",
    "modelCount_other": "{{count}} modèles",
    "tooltipComplete": "{{completed}} / {{total}} terminés ({{percent}} %)",
    "tooltipPortfolioShare": "{{percent}} % du portefeuille",
    "loop": {
      "setup": "Configuration",
      "plan": "Plan",
      "data_prep": "Préparation des données",
      "report_gen": "Génération du rapport",
      "review": "Revue",
      "test_run": "Exécution de test",
      "complete": "Terminé",
      "failed": "Échec"
    },
    "modelsLine_one": "{{count}} modèle ({{percent}} % de {{name}})",
    "modelsLine_other": "{{count}} modèles ({{percent}} % de {{name}})"
  },
  "issues": {
    "bySeverity": "Par gravité",
    "byVertical": "Par verticale",
    "noIssues": "Aucun problème",
    "noIssuesFound": "Aucun problème trouvé",
    "searchPlaceholder": "Rechercher des problèmes…",
    "filtered_one": "{{count}} problème",
    "filtered_other": "{{count}} problèmes",
    "issueCount_one": "{{count}} problème",
    "issueCount_other": "{{count}} problèmes",
    "columns": {
      "vertical": "Verticale",
      "severity": "Gravité",
      "title": "Titre",
      "theme": "Thème",
      "attribution": "Attribution",
      "status": "Statut",
      "workspace": "Espace de travail",
      "details": "Détails"
    },
    "attribution": {
      "md": "Documentation du modèle",
      "mv": "Validation du modèle",
      "unset": "(non défini)"
    },
    "status": {
      "active": "Actif",
      "archived": "Archivé"
    },
    "openWorkspace": "Ouvrir l'espace de travail →",
    "openThisWorkspace": "Ouvrir cet espace de travail",
    "openWorkspaceAria": "Ouvrir l'espace de travail {{name}}",
    "expandedAria": "Développé — cliquez sur la ligne pour réduire",
    "collapsedAria": "Réduit — cliquez sur la ligne pour développer",
    "details": "Détails"
  },
  "pipeline": {
    "searchPlaceholder": "Rechercher des espaces de travail…",
    "noWorkspaceData": "Aucune donnée d'espace de travail",
    "workspaceCount_one": "{{count}} espace de travail",
    "workspaceCount_other": "{{count}} espaces de travail",
    "hideArchived": "Masquer les archivés",
    "hideArchivedTooltip": "Les espaces de travail archivés sont masqués par défaut. Cliquez pour les afficher.",
    "showingArchived": "Affichage des archivés",
    "stageBuckets": {
      "new": "Nouveau",
      "planning": "Planification",
      "data_prep": "Préparation des données",
      "report_gen": "Génération du rapport",
      "complete": "Terminé",
      "archived": "Archivé"
    },
    "columns": {
      "workspace": "Espace de travail",
      "vertical": "Verticale",
      "stage": "Étape",
      "completenessVerdict": "Verdict de complétude",
      "issues": "Problèmes"
    },
    "completeWithErrors": "Terminé ⚠",
    "coverageVerdicts": {
      "insufficient": "Insuffisant",
      "partial": "Partiel",
      "adequate": "Adéquat",
      "comprehensive": "Exhaustif",
      "unknown": "Non évalué"
    },
    "verdictTooltip": "Verdict de complétude : {{verdict}}",
    "verdictNoCheck": "Aucune vérification de complétude enregistrée pour le moment.",
    "openWorkspace": "Ouvrir l'espace de travail",
    "openWorkspaceAria": "Ouvrir l'espace de travail {{name}}",
    "smeRating": "Note SME : {{value}}",
    "statusTooltip": "Statut : {{value}}",
    "statusTooltip_validation": "Statut de validation : {{value}}",
    "statusTooltip_auditing": "Statut de l'audit : {{value}}",
    "statusTooltip_development": "Statut du développement : {{value}}",
    "modal": {
      "createdOn": "Créé le {{date}}",
      "verticalLabel": "Verticale",
      "stageLabel": "Étape",
      "completenessVerdictLabel": "Verdict de complétude",
      "issuesPrompt": "Problèmes — cliquez sur une carte pour filtrer ci-dessous",
      "allIssues": "Tous les problèmes",
      "filteredIssues": "Problèmes {{label}}",
      "filterCount": "Affichage de {{visible}} sur {{total}} · Effacer le filtre",
      "noIssuesWorkspace": "Aucun problème enregistré pour cet espace de travail.",
      "noIssuesFilter": "Aucun problème ne correspond au filtre de gravité actuel.",
      "openWorkspaceAria": "Ouvrir l'espace de travail",
      "factsLabels": {
        "model": "Modèle",
        "modelId": "ID du modèle",
        "version": "Version",
        "scope": "Périmètre",
        "period": "Période",
        "status": "Statut",
        "rating": "Note"
      }
    },
    "unknownVertical": "Inconnu : {{value}}"
  },
  "stage": {
    "unknown": "Inconnu : {{stage}}"
  },
  "recentActivity": {
    "unavailable": "Activité récente indisponible : {{error}}",
    "noActivity": "Aucune activité au cours des 24 dernières heures"
  },
  "toolboxUsage": {
    "noRuns": "Aucune exécution dans la boîte à outils pour le moment",
    "runsByTool": "Exécutions par outil",
    "topFailures": "Principales causes d'échec",
    "runsLabel": "{{label}} ({{count}} exécutions)",
    "succeeded": "Réussies",
    "failed": "Échec",
    "cancelled": "Annulées",
    "stale": "Obsolètes"
  },
  "consumption": {
    "totalTokens": "Total des jetons",
    "inputTokens": "Jetons d'entrée",
    "outputTokens": "Jetons de sortie",
    "calls": "Appels LLM",
    "noData": "Aucune utilisation LLM enregistrée ce mois-ci",
    "tokensByModel": "Jetons par modèle",
    "dailyTrend": "Tendance quotidienne des jetons",
    "topWorkspaces": "Principaux espaces de travail",
    "toolboxBucket": "Boîte à outils (hors espace de travail)",
    "input": "Entrée",
    "output": "Sortie",
    "cache": "Cache"
  },
  "controls": {
    "executive": "Exécutif",
    "admin": "Admin",
    "scrollToTop": "Remonter en haut",
    "scrollToTopAria": "remonter en haut"
  },
  "serviceTypeSelector": {
    "withGeneric": "{{count}} · {{generic}} génériques",
    "all": "Tous les types de service",
    "allShort": "Tous"
  },
  "export": {
    "buttonLabel": "Exporter",
    "buttonTooltip": "Exporter la vue actuelle au format Excel (.xlsx)",
    "buttonAria": "Exporter les données analytiques vers Excel",
    "buttonDisabledTooltip": "Les données sont encore en cours de chargement",
    "generating": "Génération…",
    "errorTitle": "Échec de l'exportation",
    "filenamePrefix": "bennie-analytics",
    "sheets": {
      "cover": "Couverture",
      "kpi": "Résumé KPI",
      "portfolio": "Portefeuille",
      "pipeline": "Pipeline",
      "issues": "Problèmes",
      "toolbox": "Utilisation de la boîte à outils"
    },
    "cover": {
      "title": "Exportation Bennie Analytics",
      "generatedAt": "Généré le",
      "snapshotRefreshedAt": "Instantané actualisé",
      "serviceTypeFilter": "Filtre Type de service",
      "dateRangeFilter": "Plage de dates",
      "allTime": "Toutes les dates",
      "coveragePosture": "Périmètre de couverture",
      "coveragePostureBody": "L’export contient toujours l’ensemble complet des données administrateur, quelle que soit la vue Direction/Admin.",
      "sheetIndex": "Feuilles dans ce classeur",
      "rowCountSuffix": "({{count}} lignes)"
    },
    "kpi": {
      "metric": "Métrique",
      "value": "Valeur",
      "subline": "Notes",
      "totalWorkspaces": "Total des espaces de travail",
      "totalWorkspaces_validation": "Total des validations",
      "totalWorkspaces_auditing": "Total des audits",
      "totalWorkspaces_development": "Total des développements",
      "completed": "Terminées",
      "completedSub": "{{withErrors}} avec erreurs",
      "totalIssues": "Total des problèmes",
      "issuesSub": "T1:{{t1}} T2:{{t2}} T3:{{t3}} T4:{{t4}}",
      "timeSaved": "Temps gagné (heures)",
      "timeSavedSub": "D'après {{measured}} espaces de travail sur {{completed}} terminés. Ceux qui existaient déjà au démarrage de cette mesure sont exclus et leur date d'achèvement n'est jamais estimée après coup."
    },
    "portfolio": {
      "category": "Catégorie",
      "workspaceCount": "Nombre d'espaces",
      "completedCount": "Nombre terminés",
      "type1": "Type 1",
      "type2": "Type 2",
      "type3": "Type 3",
      "type4": "Type 4"
    },
    "pipeline": {
      "workspaceId": "ID espace",
      "name": "Nom espace",
      "serviceType": "Type de service",
      "vertical": "Verticale",
      "stage": "Étape",
      "coverageVerdict": "Verdict de complétude",
      "type1": "Type 1",
      "type2": "Type 2",
      "type3": "Type 3",
      "type4": "Type 4",
      "createdAt": "Créé le",
      "updatedAt": "Mis à jour le",
      "modelName": "Nom du modèle",
      "modelId": "ID du modèle",
      "scope": "Périmètre",
      "scope_validation": "Périmètre de validation",
      "scope_auditing": "Périmètre de l'audit",
      "scope_development": "Périmètre du développement",
      "period": "Période",
      "period_validation": "Période de validation",
      "period_auditing": "Période de l'audit",
      "period_development": "Période du développement",
      "rating": "Note",
      "status": "Statut",
      "status_validation": "Statut de validation",
      "status_auditing": "Statut de l'audit",
      "status_development": "Statut du développement",
      "workspaceStatus": "Statut de l'espace"
    },
    "issues": {
      "id": "ID problème",
      "workspaceId": "ID espace",
      "workspaceName": "Nom espace",
      "serviceType": "Type de service",
      "severity": "Gravité",
      "title": "Titre",
      "theme": "Thème",
      "classification": "Classification",
      "attribution": "Attribution",
      "primaryDimension": "Dimension principale",
      "rootCauseDescription": "Cause racine",
      "supportingSymptoms": "Symptômes supportant",
      "workspaceStatus": "Statut de l'espace"
    },
    "toolbox": {
      "toolId": "ID outil",
      "label": "Libellé",
      "totalRuns": "Total exécutions",
      "succeeded": "Réussies",
      "failed": "Échouées",
      "cancelled": "Annulées",
      "stale": "Obsolètes",
      "interrupted": "Interrompues",
      "active": "Actives",
      "avgDurationMs": "Durée moyenne (ms)"
    }
  },
  "verticals": {
    "unresolved": "Verticale non identifiée"
  }
}
